import React from "react";
import { formatHours } from "../../utils/timecard";

const TABS = [
  { id: "regular", label: "Regular", totalKey: "regular" },
  { id: "call", label: "Call", totalKey: "call" },
  { id: "callback", label: "Call Back", totalKey: "callBack" }
];

export default function TimecardTabs({ activeTab, totals, onChange }) {
  return (
    <div className="timecard-tabs" role="tablist" aria-label="Timecard entry type">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          id={`${tab.id}-tab`}
          type="button"
          role="tab"
          tabIndex={activeTab === tab.id ? 0 : -1}
          aria-controls={`${tab.id}-panel`}
          aria-selected={activeTab === tab.id}
          className={activeTab === tab.id ? "tab-button active" : "tab-button"}
          onClick={() => onChange(tab.id)}
        >
          <span>
            {tab.label}
            {activeTab === tab.id && (
              <span className="tab-check" aria-hidden="true">&#x2713;</span>
            )}
          </span>
          <strong>{formatHours(totals[tab.totalKey])}</strong>
        </button>
      ))}
    </div>
  );
}
